import { isProd } from '@agria/utils';

const siteLinksDev = {
  onlineCustomerClaims:
    'https://staging-lloyds-customer-online-claims.netlify.app',
  brochureware: 'https://staging-lloyds-brochure.netlify.app',
  cookiePolicy: 'https://staging-lloyds-brochure.netlify.app/cookie-policy',
  privacyPolicy: 'https://staging-lloyds-brochure.netlify.app/privacy',
  termsAndConditions: 'https://staging-lloyds-brochure.netlify.app/terms',
  multiPetTermsAndConditions:
    'https://staging-lloyds-brochure.netlify.app/terms#Multi-pet',
  hamperTermsAndConditions:
    'https://staging-lloyds-brochure.netlify.app/terms/#Hamper',
  quoteAndBuy: 'https://lloyds-quote.agriapet.co.uk',
};

const siteLinksProduction = {
  ...siteLinksDev,
  onlineCustomerClaims: 'https://lloyds-claims.agriapet.co.uk/',
  brochureware: 'https://www.lloydsbank.com/insurance/pet-insurance.html',
  cookiePolicy: 'http://lloyds.agriapet.co.uk/cookie-policy',
  privacyPolicy: 'http://lloyds.agriapet.co.uk/privacy',
  termsAndConditions: 'http://lloyds.agriapet.co.uk/terms',
  multiPetTermsAndConditions: 'http://lloyds.agriapet.co.uk/terms#Multi-pet',
  hamperTermsAndConditions: 'https://lloyds.agriapet.co.uk/terms#Hamper',
  quoteAndBuy: 'https://lloyds-quote.agriapet.co.uk',
};
export const siteLinks = isProd ? siteLinksProduction : siteLinksDev;
